
import axios from 'axios';
import BaseUrl from '../../utils/api.js';

export default class FingerPrintService {

    static getUserBiometric(page, maxPerPage, CompanyCode, userID, location, email) {
        //var data = [];
        return axios.get(`${BaseUrl}UserFingerPrint?page=${page}&maxPerPage=${maxPerPage}&CompanyCode=${CompanyCode}&userID=${userID}&location=${encodeURIComponent(location)}&email=${email}`);
    }

    static DeleteFingerPrint(UserIDList, FingerPrintList, CompanyCode, email) {     
        return axios.delete(`${BaseUrl}UserFingerPrint?UserIDList=${UserIDList}&FingerPrintList=${FingerPrintList}&CompanyCode=${CompanyCode ? CompanyCode : ''}
         &email=${email ? email : ''}`);
    }
}


// WEBPACK FOOTER //
// ./src/Services/FingerPrintService/fingerPrintService.js